import { Control, Controller, RegisterOptions } from 'react-hook-form';
import Select from 'react-select';
import { FormattedMessage } from 'react-intl';
import React, { useMemo } from 'react';
import currenciesListIso from '../../translations/currencies';
import { ShowMainTransactionDataFormViewInput } from './ShowMainTransactionDataFormView';

type Props = {
  name: string;
  control: Control<ShowMainTransactionDataFormViewInput, object>;
  rules:  Omit<RegisterOptions<ShowMainTransactionDataFormViewInput, "paymentMethod">, "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"> | undefined;

};

type CurrencyOption = { value: string; label: string; };

const CurrencySelectInputField = ({ name, control, rules }: Props) => {
  const buildCurrencyOptions = (): CurrencyOption[] => {
    return currenciesListIso.map((item) => {
      return { value: item, label: item };
    });
  };

  const currencies: CurrencyOption[] = useMemo(buildCurrencyOptions, []);

  return (
    <Controller
      name="currencyCode"
      control={control}
      rules={rules}
      render={({ field }) => (
        <Select
          {...field}
          inputId="currency-select-input"
          placeholder={<FormattedMessage id="selectCurrency.placeholder" />}
          noOptionsMessage={() => (
            <FormattedMessage id="selectCurrency.noOption" />
          )}
          onChange={(value) => {
            field.onChange(value);
          }}
          options={currencies}
          isClearable={false}
          name={name}
          classNamePrefix="currency-select"
          maxMenuHeight={100}
        />
      )}
    />
  );
};
export default CurrencySelectInputField;
